<div class="container mt-4">
    <div class="row">
        <div class="col-6 p-0">
            <app-table-search-bar [tableData]="tableData" (updateTextFilters)="updateTextFilters($event)"
                (sendSearchedWord)="updateSearchedWord($event)"></app-table-search-bar>
        </div>
        <div class="d-flex justify-content-end offset-4 align-items-center col-2 p-0 mb-2">
            <button class="btn green-link d-flex" (click)="refreshDocuments()"><span
                    class="d-none d-sm-block">{{ 'table.buttons.refresh' | translate }}</span> <span
                    class="material-icons align-middle pl-1">sync</span></button>
        </div>
        <div class="col-12 p-0">
            <app-table-text-filters (deleteTextFilters)="deleteTextFilters($event)" [pills]="textFilters$ | async">
            </app-table-text-filters>
        </div>
        <div class="col-12 p-0">
            <!-- Add searchedWord input -->
            <app-dynamic-table [textFilters]="textFilters$ | async" [columnNames]="columnsConfig$ | async" [searchedText]="searchedWord" [tableData]="tableData"></app-dynamic-table>
        </div>
        <div class="col-12 mt-3 p-0">
            <app-table-buttons-wrapper [buttonsConfig]="buttonsConfig$ | async" (sendInfo)="getButtonInfo($event)">
            </app-table-buttons-wrapper>
        </div>
    </div>
</div>